import { render, staticRenderFns } from "./TheModalConsultaExterna.vue?vue&type=template&id=28d19e96&"
import script from "./TheModalConsultaExterna.vue?vue&type=script&lang=js&"
export * from "./TheModalConsultaExterna.vue?vue&type=script&lang=js&"
import style0 from "./TheModalConsultaExterna.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports